import { Immutable } from "immer";
import React from "react";

import { WebPageURL } from "../../../models/nominals";
import { preferredLocationSelector } from "../../../store/common/selectors";
import { useAppSelector } from "../../../store/reducers";
import { filteredStoreSelector } from "../selectors";
import { RetailCardsBlock } from "./RetailCardsContent";

export const RetailCards = (
    props: Immutable<{
        retailLocatorLink: WebPageURL;
    }>,
): React.ReactNode => {
    const location = useAppSelector(preferredLocationSelector);
    const stores = useAppSelector(filteredStoreSelector);

    return (
        <RetailCardsBlock
            location={location}
            stores={stores}
            retailLocatorLink={props.retailLocatorLink}
        />
    );
};
